import { render, staticRenderFns } from "./StockInventoryTasks.vue?vue&type=template&id=5a1a25f6&scoped=true&"
import script from "./StockInventoryTasks.vue?vue&type=script&lang=js&"
export * from "./StockInventoryTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a25f6",
  null
  
)

export default component.exports
import {QBtn,QTr,QTh,QTd,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QTr,QTh,QTd,QTooltip}, component.options.components || {})
